import React from 'react';
import { KanbanSquare } from 'lucide-react';

const KanbanSkeleton: React.FC = () => {
  return (
    <div className="max-w-[1600px] mx-auto space-y-6 animate-pulse">
      <div className="h-8 w-56 bg-zinc-200 rounded-lg" />
      <div className="h-4 w-80 bg-zinc-100 rounded-lg" />
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-24 bg-white border border-zinc-200 rounded-card p-4">
            <div className="h-3 w-20 bg-zinc-200 rounded mb-3" />
            <div className="h-7 w-16 bg-zinc-200 rounded" />
          </div>
        ))}
      </div>
      <div className="flex gap-4 overflow-hidden">
        {Array.from({ length: 5 }).map((_, col) => (
          <div key={col} className="w-[290px] shrink-0 h-[520px] bg-white border border-zinc-200 rounded-card p-3">
            <div className="h-4 w-24 bg-zinc-200 rounded mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 3 }).map((_, card) => (
                <div key={card} className="h-28 bg-zinc-100 rounded-card" />
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 text-xs text-zinc-400">
        <KanbanSquare className="w-4 h-4" />
        Loading your board…
      </div>
    </div>
  );
};

export default KanbanSkeleton;